import { useMutation } from '@tanstack/react-query';
import { createTenant as createTenantService } from 'services/api/AccessManagerAPI';

export const useCreateTenant = () => {
    const { mutateAsync: createTenant, isPending } = useMutation({
        mutationFn: createTenantService,
        retry: false,
    });

    return { createTenant, isPending };
};
